module.exports = __webpack_public_path__ + "img/ic_home.078bcc9d.svg";